import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

// Referral forwarder for iter 25 links: {frontend}/get-started?ref=CODE
// Redirects into the existing player-signup form with the ref preserved.
export default function GetStarted() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  useEffect(() => {
    const ref = (params.get("ref") || "").trim();
    const qs = ref ? `?ref=${encodeURIComponent(ref)}` : "";
    nav(`/register/player${qs}`, { replace: true });
  }, [params, nav]);
  return <div className="p-10 text-[#8B97AE]" data-testid="get-started-forwarder">Redirecting…</div>;
}
